import { lighterGray, white } from '../../constants/colorConstants'

const expandableViewStyles = {
  panel: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    backgroundColor: lighterGray,
    padding: '30px 0',
    margin: '-6px',
    marginRight: '-16px',
  },
  infoColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    margin: '0 80px',
  },
  tableColumn: {
    backgroundColor: white,
    width: '768px',
    borderRadius: '8px',
  },
}

export default expandableViewStyles
